import useAmplitude from '@eversports/amplitude-react/useAmplitude'

import ParticipatingFriends from '../../../../../ActivityDetails/FriendAttending/ParticipatingFriends'

import { PublicParticipation } from './FriendsUpcomingParticipations.types'
import FriendUpcomingParticipationCard from './FriendUpcomingParticipationCard'
import { FriendUpcomingParticipationVariant } from './FriendUpcomingParticipationVariant'

interface Props {
  upcomingParticipation: PublicParticipation
}

const FriendUpcomingParticipation = ({ upcomingParticipation }: Props) => {
  const { amplitude } = useAmplitude()

  const attendingFriends = {
    nodes: upcomingParticipation.attendingFriends?.edges.map((edge) => edge.node) || [],
  }

  const showParticipatingFriends = attendingFriends.nodes.length > 0

  const handleClick = () => {
    if (!amplitude) return
    amplitude.logEvent(' Clicked Friends Upcoming Activities Tile', {
      type: upcomingParticipation.__typename === 'PublicEventSessionParticipation' ? 'activity' : 'court booking',
    })
  }

  return (
    <FriendUpcomingParticipationCard>
      <FriendUpcomingParticipationVariant upcomingParticipation={upcomingParticipation} onClick={handleClick} />
      {showParticipatingFriends && <ParticipatingFriends friends={attendingFriends} />}
    </FriendUpcomingParticipationCard>
  )
}

export default FriendUpcomingParticipation
